export { useIsDesktop } from "@my-scoot/exly-react-component-lib/build/esm/utils/common/screen";
